import {
  httpCollection,
  versionedHttpCollection,
} from "us.helper/http/collection";

export default {
  search: {
    init: (): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const standardRatesList = await httpCollection.get(
            "entityservice",
            `entities/standardrates`,
            {}
          );

          const standardRatesHistory = await httpCollection.get(
            "entityservice",
            "entities/standardratesupdatehistory",
            {}
          );

          resolve({
            standardRatesList,
            standardRatesHistory,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: ({
      rateId,
      comment,
    }: {
      rateId: number;
      comment: string;
    }): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const deleteData = await versionedHttpCollection.delete(
            "entityservice",
            `entities/standardrate`,
            rateId,
            { comment: comment ? comment : "" },
            "v1"
          );

          resolve({
            deleteData: deleteData.data,
            status: deleteData.status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  detail: {
    add: ({ saveParams }: { saveParams: any }): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const save = await httpCollection.post(
            "entityservice",
            "entities/standardrate",
            saveParams
          );

          resolve({
            saveData: save.data,
            saveStatus: save.status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    edit: ({ saveParams }: { saveParams: any }): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const save = await httpCollection.put(
            "entityservice",
            "entities/standardrate",
            saveParams
          );

          resolve({
            saveData: save.data,
            saveStatus: save.status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
